import dynamicYieldClient from 'src/utils/dynamicYield/dynamicYieldClient'

import { ensureDYCookies } from './dynamicYieldCookies'
import type { DynamicYieldPageView } from './types/dynamicYieldTypes'

export default async function dynamicYieldPageView({
  page,
  data = [],
}: DynamicYieldPageView) {
  try {
    const { dyid, dyidServer, sessionId } = await ensureDYCookies()

    const location = new URL(window?.location?.href ?? '')

    if (!location || !dyid || !dyidServer || !sessionId) {
      return
    }

    const pageViewData = {
      user: { active_consent_accepted: true, dyid, dyid_server: dyidServer },
      session: { dy: sessionId },
      context: {
        page: {
          type: page,
          data,
          location,
          referrer: document?.referrer ?? '',
          locale: 'pt-BR',
        },
        device: {
          userAgent: navigator?.userAgent ?? '',
        },
        channel: 'WEB',
      },
      options: { isImplicitClientData: true },
    }

    const result = await dynamicYieldClient.post(
      '/pageview',

      pageViewData
    )

    console.info(`Dynamic Yield Page View (${page}): `, result.data)
  } catch (error) {
    console.error(`Error sending Dynamic Yield page (${page}): `, error)
  }
}
